/** @jsx jsx */

import {
  SkeletonLoader,
  SkeletonText,
  Spacer,
  Text,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { useQueryZapierSession } from 'app/developer-v3/hooks';

import Button from '../Button';
import Page from '../Page';
import FieldService from './FieldService';

import type { Service } from './types';

const Styles = {
  submit: css`
    text-align: center;
  `,
};

type Props = {
  service?: Service;
  isSubmitting: boolean;
  onChangeService: (service: Service) => void;
  onSubmit: ({ email, service }: { email: string; service: Service }) => void;
};

function Form(props: Props) {
  const { service, isSubmitting, onChangeService, onSubmit } = props;
  const { isLoading: isLoadingUser, data } = useQueryZapierSession();
  const email = data?.email;

  return (
    <Page>
      <Text tag="h1" type="SectionHeader">
        Join an integration as a collaborator
      </Text>
      <Spacer height={30} />
      <Text tag="p">
        Get view only access to your Zapier integration. You can view
        performance data, user feedback, and access embed tools.
      </Text>
      <Text margin="20px 0 0" tag="p">
        You will be joining with your Zapier account:
      </Text>
      {isLoadingUser ? (
        <SkeletonLoader>
          <Spacer height={5} />
          <SkeletonText lines={1} />
        </SkeletonLoader>
      ) : (
        <Text tag="p" type="Body4">
          {email}
        </Text>
      )}
      <Spacer height={20} />
      <FieldService onChangeService={onChangeService} />
      <Spacer height={35} />
      <div css={Styles.submit}>
        <Button
          isDisabled={email !== undefined && !service}
          isWorking={isSubmitting}
          onClick={() => onSubmit({ email, service })}
        >
          Submit
        </Button>
      </div>
    </Page>
  );
}

export default Form;
